export const unitTypes = [
    {
        value: '',
        label: 'Please choose....'
    },
    {
        value: 'COTTAGE',
        label: 'Cottage'
    },
    {
        value: 'DUPLEX',
        label: 'Duplex'
    },
    {
        value: 'FACTORY',
        label: 'Factory'
    },
    {
        value: 'HOUSE',
        label: 'House'
    },
    {
        value: 'KIOSK',
        label: 'Kiosk'
    },
    {
        value: 'LEVEL',
        label: 'Level'
    },
    {
        value: 'MAISONETTE',
        label: 'Maisonette'
    },
    {
        value: 'MARINEBERTH',
        label: 'Marine Berth'
    },
    {
        value: 'OFFICE',
        label: 'Office'
    },
    {
        value: 'PENTHOUSE',
        label: 'Penthouse'
    },
    {
        value: 'REAR',
        label: 'Rear'
    },
    {
        value: 'ROOM',
        label: 'Room'
    },
    {
        value: 'SHOP',
        label: 'Shop'
    },
    {
        value: 'STALL',
        label: 'Stall'
    },
    {
        value: 'SITE',
        label: 'Site'
    },
    {
        value: 'SUITE',
        label: 'Suite'
    },
    {
        value: 'TOWNHOUSE',
        label: 'Townhouse'
    },
    {
        value: 'UNIT',
        label: 'Unit'
    },
    {
        value: 'VILLA',
        label: 'Villa'
    },
    {
        value: 'WARD',
        label: 'Ward'
    },
    {
        value: 'OTHER',
        label: 'Other'
    }
];
/**
 * Mapping of unitType responses from Hopewiser data to our DB.
 * @deprecated
 * @type {Object}
 */
export const unitTypeMap = {
    CO: 'COTTAGE',
    DU: 'DUPLEX',
    FA: 'FACTORY',
    HO: 'HOUSE',
    KI: 'KIOSK',
    L: 'LEVEL',
    M: 'MAISONETTE',
    MA: 'MARINE BERTH',
    OF: 'OFFICE',
    PE: 'PENTHOUSE',
    RE: 'REAR',
    RO: 'ROOM',
    SH: 'SHOP',
    ST: 'STALL',
    SI: 'SITE',
    SU: 'SUITE',
    TO: 'TOWNHOUSE',
    UN: 'UNIT',
    VI: 'VILLA',
    WA: 'WARD',
    OT: 'OTHER'
};
